import assetsExplorerModule from "../assetsExplorerModule.js";
import { AssetsExplorerModel } from "Roblox";

function assetsExplorerController($scope, assetsMessageService, assetsConstants, assetsService) {
    "ngInject";
    var ctrl = this;

    var layoutData = Object.assign({}, assetsConstants.defaultLayoutData);

    ctrl.shouldShowPremiumIcon = function (item) {
        if (!layoutData.isPremiumIconOnItemTilesEnabled) {
            return false;
        }
        
        if (!item.Product || !item.Product.PremiumPriceInRobux) {
            return false;
        }

        return true;
    }

    ctrl.getDisplayPrice = function (item) {
        if (!item.Product) {
            return;
        }

        if (layoutData.isPremiumPriceOnItemTilesEnabled && item.Product.PremiumPriceInRobux) {
            return item.Product.PremiumPriceInRobux;
        }
        
        return item.Product.PriceInRobux;
    }

    ctrl.doesItemHavePrice = function (item) {
        if (!item.Product) {
            return false;
        }

        if (!item.Product.PriceInRobux && (!item.Product.PremiumPriceInRobux || !layoutData.isPremiumPriceOnItemTilesEnabled)) {
            return false;
        }

        return true;
    }

    var init = function () {
        $scope.assetsPager = ctrl.assetsPager;
        ctrl.staticData = AssetsExplorerModel;
        ctrl.assetsConstants = assetsConstants;
        ctrl.getInventoryEmptyMessage = assetsMessageService.getInventoryEmptyMessage;
        ctrl.getInventoryNewItemsMessage = assetsMessageService.getInventoryNewItemsMessage;
        ctrl.showMessageToFindNewItems = assetsMessageService.showMessageToFindNewItems;
        ctrl.getExploreMessage = assetsMessageService.getExploreMessage;

        assetsService.getCatalogMetadata().then(function success(result) {
            const {
              isPremiumIconOnItemTilesEnabled,
              isPremiumPriceOnItemTilesEnabled
            } = result;

            layoutData.isPremiumIconOnItemTilesEnabled = isPremiumIconOnItemTilesEnabled;
            layoutData.isPremiumPriceOnItemTilesEnabled = isPremiumPriceOnItemTilesEnabled;
        });
    };

    ctrl.$onInit = init;
}

assetsExplorerModule.controller("assetsExplorerController", assetsExplorerController);
export default assetsExplorerController;